const ENTERPRISE_DISTRIBUTION_ID = 'enterprise';
const ENTERPRISE_API_PATH_SEGMENT = 'xcustom-platform';
// 这些 service 在 enterprise 部署时需要 `/xcustom-platform` 前缀。
// 与 GlobalClientInit 里 client interceptor 的覆盖范围保持一致；claw/craftify 等不在列表，运行时不改写。
const ENTERPRISE_SERVICES = new Set(['vidu', 'iam', 'tools', 'credit', 'infer']);

const isEnterpriseDistribution = process.env.NEXT_PUBLIC_DISTRIBUTION === ENTERPRISE_DISTRIBUTION_ID;

/**
 * 把一条逻辑 API path 解析为当前构建实际可发的 path。
 *
 * 调用方持有的是公网形态 `/<service>/v1/...`，但 enterprise 构建下后端真正接收的是
 * `/<service>/xcustom-platform/v1/...`。这个函数把环境差异封装在一处，调用点不用关心。
 *
 *   enterprise 构建下：
 *     /vidu/v1/tasks/state         → /vidu/xcustom-platform/v1/tasks/state
 *     /credit/v1/orders/state      → /credit/xcustom-platform/v1/orders/state
 *     /claw/v1/...                 → 不变（claw 不在白名单）
 *   公网构建：原样返回。
 *
 * 适用：非 SDK 的裸 fetch / SSE。SDK 调用由 GlobalClientInit 注册的 client interceptor 统一
 * 处理，调用点不需要再调本函数。
 *
 * 幂等：已含 `/xcustom-platform/` 的 path 原样返回；第一段 service 不在白名单时也原样返回
 * （保护 claw/craftify 等不需要前缀的 service）。
 */
export const resolveApiPath = (path: string): string => {
  if (!isEnterpriseDistribution || !path) return path;
  if (path.includes(`/${ENTERPRISE_API_PATH_SEGMENT}/`)) return path;
  const match = path.match(/^\/([^/]+)/);
  if (!match || !ENTERPRISE_SERVICES.has(match[1])) return path;
  return path.replace(/^(\/[^/]+)/, `$1/${ENTERPRISE_API_PATH_SEGMENT}`);
};

// SDK baseUrl：保持原始 origin。enterprise 构建下 SDK 请求 URL 由 GlobalClientInit 注册的
// client interceptor 在出门前统一注入 `/xcustom-platform`，baseUrl 本身保持纯净。
export const API_ORIGIN = process.env.NEXT_PUBLIC_API_ORIGIN ?? '';

// 服务端裸 fetch 用的 vidu service origin（值形如 `<backend>/vidu`）。
// enterprise 构建下在末尾追加 `/xcustom-platform`，使所有 `${API_ORIGIN_VIDU}${path}` 调用点
// 自动得到 `<backend>/vidu/xcustom-platform${path}` —— 无需逐个改。
const SERVER_API_ORIGIN_VIDU = (process.env.SERVER_API_ORIGIN_VIDU ?? '').replace(/\/+$/, '');
export const API_ORIGIN_VIDU = isEnterpriseDistribution
  ? `${SERVER_API_ORIGIN_VIDU}/${ENTERPRISE_API_PATH_SEGMENT}`
  : SERVER_API_ORIGIN_VIDU;

export const NETWORK_SETTINGS: {
  baseUrl: string;
  credentials: RequestCredentials;
} = {
  baseUrl: API_ORIGIN,
  credentials: 'include',
};
